import { Language } from '../../lang/Language'
import {
  AllIn,
  Disconnected,
  Folded,
  ForeverOut,
  InPlay,
  Observer,
  Out,
  PlayerState,
  SitOut,
  Waiting
} from './PlayerState.types'

export class PlayerStates {
  public static Waiting: Waiting = <Waiting>{
    tag: 'waiting',
    description: Language.strings.states.player.waiting
  }

  public static InPlay: InPlay = <InPlay>{
    tag: 'inplay',
    description: Language.strings.states.player.inplay
  }

  public static Folded: Folded = <Folded>{
    tag: 'folded',
    description: Language.strings.states.player.folded
  }

  public static AllIn: AllIn = <AllIn>{
    tag: 'allin',
    description: Language.strings.states.player.allin
  }

  public static Out: Out = <Out>{
    tag: 'out',
    description: Language.strings.states.player.out
  }

  public static SitOut: SitOut = <SitOut>{
    tag: 'sitout',
    description: Language.strings.states.player.sitOut
  }

  public static ForeverOut: ForeverOut = <ForeverOut>{
    tag: 'foreverout',
    description: Language.strings.states.player.foreverOut
  }

  public static Disconnected: Disconnected = <Disconnected>{
    tag: 'disconnected',
    description: Language.strings.states.player.disconnected
  }

  public static Observer: Observer = <Observer>{
    tag: 'observer',
    description: Language.strings.states.player.observer
  }

  static isWaiting(s: PlayerState): s is Waiting {
    return s.tag === 'waiting'
  }

  static isInPlay(s: PlayerState): s is InPlay {
    return s.tag === 'inplay'
  }

  static isFolded(s: PlayerState): s is Folded {
    return s.tag === 'folded'
  }

  static isAllIn(s: PlayerState): s is AllIn {
    return s.tag === 'allin'
  }

  static isOut(s: PlayerState): s is Out {
    return s.tag === 'out'
  }

  static isSitOut(s: PlayerState): s is SitOut {
    return s.tag === 'sitout'
  }

  static isForeverOut(s: PlayerState): s is ForeverOut {
    return s.tag === 'foreverout'
  }

  static isDisconnected(s: PlayerState): s is Disconnected {
    return s.tag === 'disconnected'
  }

  static isObserver(s: PlayerState): s is Observer {
    return s.tag === 'observer'
  }
}
